import { Anchor, HoverCard, type HoverCardProps } from '@mantine/core';
import type { ReactElement } from 'react';
import { Link } from 'react-router-dom';

import { ClientHoverCardContent } from './ClientHoverCardContent';

type ClientHoverCardProps = {
  debtorId: string;
  debtorName: string;
  children?: ReactElement;
} & Pick<HoverCardProps, 'position' | 'offset' | 'width'>;

export const ClientHoverCard = ({
  debtorId,
  debtorName,
  children,
  position = 'bottom-start',
  offset,
  width,
}: ClientHoverCardProps) => (
  <HoverCard
    openDelay={150}
    closeDelay={100}
    position={position}
    withinPortal
    offset={offset}
    width={width}
    shadow="md"
    radius="md"
  >
    <HoverCard.Target>
      {children ?? (
        <Anchor
          component={Link}
          to={`/clients/${debtorId}`}
          fz="inherit"
          truncate
          onClick={e => {
            e.stopPropagation();
          }}
        >
          {debtorName}
        </Anchor>
      )}
    </HoverCard.Target>
    <HoverCard.Dropdown onClick={e => e.stopPropagation()} onDoubleClick={e => e.stopPropagation()}>
      <ClientHoverCardContent debtorId={debtorId} debtorName={debtorName} />
    </HoverCard.Dropdown>
  </HoverCard>
);
